import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-sm-12 bg-white p-0" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-4 p-5 px-xl-10" }
const _hoisted_4 = { class: "badge bg-secondary" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_6 = { class: "col-lg-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.linkLocation,
    class: "row mt-5 portfolio-preview shadow"
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("h4", null, _toDisplayString(_ctx.data.name), 1),
            _createVNode("p", null, _toDisplayString(_ctx.data.description), 1),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(Object.values(_ctx.data.badges).flat(), (b) => {
              return (_openBlock(), _createBlock(_Fragment, { key: b }, [
                _createVNode("span", _hoisted_4, _toDisplayString(b), 1),
                _hoisted_5
              ], 64))
            }), 128))
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("img", {
              src: _ctx.data.previewImgSrc,
              class: "img-fluid float-end",
              alt: ""
            }, null, 8, ["src"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}